import { defineMessages } from 'react-intl'

export default defineMessages({
  turnaroundTimeLabel: {
    id: 'components.SupplierTurnaround.turnaroundTimeLabel',
    defaultMessage: 'Turnaround time',
  },
  turnaroundTimeDescriptionSupplier: {
    id: 'components.SupplierTurnaround.turnaroundTimeDescriptionSupplier',
    defaultMessage: 'The time that you take to deliver',
  },
  turnaroundTimeDescriptionCoordinator: {
    id: 'components.SupplierTurnaround.turnaroundTimeDescriptionCoordinator',
    defaultMessage: 'The time that the supplier takes to deliver',
  },
  dayTimeLabel: {
    id: 'components.SupplierTurnaround.dayTimeLabel',
    defaultMessage: 'Day time',
  },
  dayTimeDescriptionSupplier: {
    id: 'components.SupplierTurnaround.dayTimeDescriptionSupplier',
    defaultMessage: 'Time range where you will be available during the day',
  },
  dayTimeDescriptionCoordinator: {
    id: 'components.SupplierTurnaround.dayTimeDescriptionCoordinator',
    defaultMessage: 'Time range where supplier will be available during the day',
  },
  nightTimeLabel: {
    id: 'components.SupplierTurnaround.nightTimeLabel',
    defaultMessage: 'Night time',
  },
  nightTimeDescriptionSupplier: {
    id: 'components.SupplierTurnaround.nightTimeDescriptionSupplier',
    defaultMessage: 'Time range where you will be available during the night',
  },
  nightTimeDescriptionCoordinator: {
    id: 'components.SupplierTurnaround.nightTimeDescriptionCoordinator',
    defaultMessage: 'Time range where supplier will be available during the night',
  },
  weekendAvailabilityLabel: {
    id: 'components.SupplierTurnaround.weekendAvailabilityLabel',
    defaultMessage: 'Available during Weekends?',
  },
  validationFailed: {
    id: 'components.SupplierTurnaround.validationFailed',
    defaultMessage: 'Turnaround time is required.',
  }
})
